// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import messageSquare02Icon from "@/assets/icons/message-square-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MessageSquare02IconProps = Omit<IconProps, "name">;

export function MessageSquare02Icon(props: MessageSquare02IconProps): React.ReactNode {
  return <Icon name={messageSquare02Icon} {...props} />;
}
